import React from 'react';
import { withTranslation } from "react-i18next";
import CaProfileScoreView from "./CaProfileScoreView";

class CaProfileScoreContainer extends React.Component {
    constructor(props){
        super(props);
    }
    render(){
        const {userScore, maxPoints, maxUserScore}=this.props;

        return(
            <CaProfileScoreView

                title={this.props.t('account_page.score.header')}
                scoreLabel={this.props.t('account_page.score.score_label')}
                topScoreLabel={this.props.t('account_page.score.top_score_label')}
                minLabel={this.props.t('account_page.score.min_label')}
                maxLabel={this.props.t('account_page.score.max_label')}

                userScore={Math.min(userScore,maxPoints)}
                maxPossibleScore={maxPoints}
                maxUserScore={Math.min(maxUserScore,maxPoints)}
            />
        )
    }
}

export default withTranslation("translations")(CaProfileScoreContainer);





